import { VariaveisPainel } from '../../conteudo/ui/VariaveisPainel';
import { PontuacaoPainel } from '../../pontuacao/ui/PontuacaoPainel';
import { LabPixelsConfiguracao } from './LabPixelsConfiguracao';
import { MenuResolucaoConfiguracao } from './MenuResolucaoConfiguracao';
import { Player1Configuracao } from './Player1Configuracao';
import { ScanPixelConfiguracao } from './ScanPixelConfiguracao';
import { VersusConfiguracao } from './VersusConfiguracao';

/** As fases que viram aba em Configurações, na ordem da jornada. */
export const FASES_DE_CONFIGURACAO = [
    { id: 'scanpixel', rotulo: 'Scan Pixel' },
    { id: 'menuresolucao', rotulo: 'Menu Resolução' },
    { id: 'labpixels', rotulo: 'Laboratório de Pixels' },
    { id: 'versus', rotulo: 'Modo Versus' },
    { id: 'player1', rotulo: 'Player 1' },
] as const;

export type FaseDeConfiguracao = (typeof FASES_DE_CONFIGURACAO)[number]['id'];

/**
 * A aba de uma fase em Configurações: junta o que antes ficava em abas separadas — as variáveis da
 * fase, as regras de pontuação dela e, no Scan Pixel, os materiais que os enigmas liberam. As
 * rotas são as mesmas de antes; o Menu Resolução ganhou a dele no adm-backend.
 */
export function ConfiguracaoDaFase({ fase, csrfToken }: { fase: FaseDeConfiguracao; csrfToken: string }) {
    // Scan Pixel já tem a tela do modelo: enigmas com pistas, Pontuação e Materiais num salvar só.
    if (fase === 'scanpixel') return <ScanPixelConfiguracao csrfToken={csrfToken} />;
    if (fase === 'labpixels') return <LabPixelsConfiguracao csrfToken={csrfToken} />;
    if (fase === 'versus') return <VersusConfiguracao csrfToken={csrfToken} />;
    if (fase === 'player1') return <Player1Configuracao csrfToken={csrfToken} />;
    if (fase === 'menuresolucao') return <MenuResolucaoConfiguracao csrfToken={csrfToken} />;
    return (
        <div className="configuracao-da-fase">
            <VariaveisPainel fase={fase} csrfToken={csrfToken} />
            <PontuacaoPainel fase={fase} csrfToken={csrfToken} />
        </div>
    );
}
